var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.outcome.id > 0 || _vm.showEmptyOutcome)?_c('span',{class:[
    'bto-sb-event-odd',
    {
      'bto-sb-odd-lock':
        (_vm.outcome.outcome === '--' && !_vm.showEmptyOutcome) ||
        _vm.outcome.active === false ||
        _vm.match.isBetStop ||
        _vm.checkSuspended(),
      'bto-sb-event-odd-active': _vm.checkOddActive() && !_vm.match.isBetStop,
      [_vm.updateClasses[`class-${_vm.outcome.upDownClass}`]]: true,
      'bto-sb-event-odd-x': _vm.outcome.name === _vm.xOutcomeName,
    },
    _vm.quickBetClasses,
  ],on:{"click":function($event){$event.preventDefault();return _vm.processOdd()}}},[(_vm.getQuickBetNotification && _vm.getQuickBetNotification.betslip.status === 4)?_c('span',{staticClass:"bto-sb-spinner-v1"}):_vm._e(),(_vm.usShortName && !_vm.expandedView)?[_c('i',[_vm._v(_vm._s(_vm.usShortName))]),_c('i',[_vm._v(_vm._s(_vm.formatedOutcome))])]:(!_vm.expandedView)?_c('Fragment',[_vm._v(" "+_vm._s(_vm.formatedOutcome)+" ")]):_c('Fragment',[_c('i',[_vm._v(_vm._s(_vm.getExpandedViewOutcomeData))]),_c('i',[_vm._v(_vm._s(_vm.formatedOutcome))])])],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }